import React, { useState, useEffect } from "react";
import { IResourceComponentsProps, useOne } from "@pankod/refine-core";

import { getQueryParam } from "../../../utility/queryParams";
import { ListingCbPageTable } from "./components/table/listing-cb-page.table";
import { Show } from "@pankod/refine-antd";
import { CreateEaseBuzzWireCbModal } from "./components/modal/create-eb-cb-account.model";
import { ICompany } from "../../../interfaces";
import { CreateTransBnkCbModal } from "./components/modal/create-transbank-account.model";
import { ConnectedBankingStatus } from "../../../interfaces/integrator";
import BackTitle from "components/back-title";

export const ConnectedBankingList: React.FC<IResourceComponentsProps> = () => {
    let [status, setStatus] = useState<any>();
    let [companyId, setCompanyId] = useState<string>();

    let [refreshTableData, setRefreshTableData] = useState(false);

    const { data: easebuzzData } = useOne<any>({
        id: '',
        resource: `banking-delegated-access/internal-portal/bank-integration/merchant/EASEBUZZ`,
    });

    const { data: transBnkData } = useOne<any>({
        id: '',
        resource: `banking-delegated-access/internal-portal/bank-integration/merchant/TRANSBNK`,
    });

    let { data: companyData, isLoading: companyLoading } = useOne<ICompany>({
        id: '',
        dataProviderName: "grapghQl",
        resource: 'getCompaniesForManagementPortal',
        metaData: {
            filter: { id: companyId, },
            tableRefetch: refreshTableData
        },
        queryOptions: {
            enabled: true,
        },
    });

    const setTableRefetch = (message: boolean) => {
        setRefreshTableData(message);
    };

    const companyDetail: ICompany | undefined = companyData?.data;
    const easeBuzzOptions = easebuzzData?.data.map((e: any) => ({
        value: e.id,
        label: e.name
    })) || [];

    const transBnkOptions = transBnkData?.data.map((e: any) => ({
        value: e.id,
        label: e.name,
    }))

    useEffect(() => {
        const companyId = getQueryParam("companyId");
        const cbStatus = getQueryParam("status");
        if (companyId) {
            setCompanyId(companyId)
        }
        if (cbStatus) {
            setStatus(ConnectedBankingStatus[cbStatus])
        }
    }, []);

    useEffect(() => {
        setTableRefetch(false)
    }, [refreshTableData]);

    return (
        <Show
            isLoading={companyLoading}
            title={<BackTitle title="Kodo Connected Banking" />}
            headerButtons={({ defaultButtons }) => (
                <>
                    {companyDetail &&
                        <CreateTransBnkCbModal
                            companyDetail={companyDetail}
                            refetchTableProps={setTableRefetch}
                            transBnkListingOptions={transBnkOptions}
                        />
                    }
                    {companyDetail &&
                        <CreateEaseBuzzWireCbModal
                            companyDetail={companyDetail}
                            refetchTableProps={setTableRefetch}
                            easebuzzListingOptions={easeBuzzOptions}
                        />
                    }
                </>
            )}
        >
            {companyDetail && <ListingCbPageTable companyDetail={companyDetail.id} cbStatus={status} refreshTableData={refreshTableData}/> }
        </Show>
    );
};